var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtmIcnStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91509 0.25C7.19898 0.25 7.45103 0.456573 7.5408 0.762829L12.1916 16.6283L14.2041 9.76283C14.2939 9.45657 14.5459 9.25 14.8298 9.25H18.3475C18.7118 9.25 19.0071 9.58579 19.0071 10C19.0071 10.4142 18.7118 10.75 18.3475 10.75H15.3052L12.8173 19.2372C12.7275 19.5434 12.4755 19.75 12.1916 19.75C11.9077 19.75 11.6556 19.5434 11.5659 19.2372L6.91509 3.37171L4.90255 10.2372C4.81278 10.5434 4.56073 10.75 4.27684 10.75H0.759172C0.394905 10.75 0.0996094 10.4142 0.0996094 10C0.0996094 9.58579 0.394905 9.25 0.759172 9.25H3.80145L6.28937 0.762829C6.37915 0.456573 6.63119 0.25 6.91509 0.25Z",
    fill: "#444EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmIcnStroke);
export default __webpack_public_path__ + "static/media/atm-icn-stroke.7ac5570062919253382ed197bcc3418b.svg";
export { ForwardRef as ReactComponent };